<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { nToWord } from '@/utils/helpers'

export default {
  name: 'RexDurations',
  components: {
    vueCustomScrollbar
  },
  props: {
    name: {
      type: String,
      required: true
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getter: {
      type: String,
      default: () => 'getField'
    },
    setter: {
      type: String,
      default: () => 'setField'
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    nightsCount: {
      type: Number,
      default: () => 29
    },
    marked: {
      type: Array,
      default: () => []
    },
    position: {
      type: String,
      default: () => null
    },
    legend: {
      type: Array,
      default: () => []
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
    label: {
      type: String,
      default: () => null
    },
    hasBackendValidation: {
      type: Boolean,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
  },
  data: () => ({
    active: false
  }),
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getter}`](this.target)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setter}`, {
          target: this.target,
          value
        })

        if (this.error !== null && this.hasBackendValidation) {
          const target = this.target.split('.')
          const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          const currentFieldErrorIndex = err.map(x => x.source).indexOf(this.name)

          err.splice(currentFieldErrorIndex, 1)

          this.$store.commit(`${this.storeModule}/${this.setter}`, err)
        }

        this.$emit('change', {
          element: this.$vnode.elm,
          event: value
        })
      }
    },
    labeledValue() {
      return `${this.value} ${nToWord(this.value, ['ночь', 'ночи', 'ночей'])}`
    },
    error() {
      let error = null

      if (this.hasBackendValidation) {
        const target = this.target.split('.')
        const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          .find(item => item.source === this.name)

        error = err ? err.detail : null
      }

      return error
    },
  },
  methods: {
    toggleFocus(active) {
      this.active = active
    },
    hideDropdown() {
      this.$refs.dropdown.toggle()
    }
  }
}
</script>
<template>
  <b-field
    custom-class="rex-label"
    :label="label"
    :type="{'is-danger': errors.has(name) || error}"
    :message="errors.first(name) || error"
  >
    <div class="rex-durations">
      <b-dropdown
        ref="dropdown"
        @active-change="toggleFocus"
      >
        <button
          slot="trigger"
          class="rex-durations__trigger"
          :class="{
            'rex-durations__trigger--has-error': errors.has(name) || error,
            'rex-durations__trigger--disabled': isDisabled,
            'rex-durations__trigger--active': active
          }"
          :disabled="isDisabled"
        >
          {{ labeledValue }}
        </button>
        <div class="rex-durations__list">
          <vue-custom-scrollbar class="rex-durations__scrollbar">
            <b-dropdown
              v-model="value"
              :inline="true"
            >
              <b-dropdown-item
                v-for="item in nightsCount"
                :key="item"
                :value="item"
                class="rex-durations__list-item"
                :class="{
                  'rex-durations__list-item--marked': marked.includes(item)
                }"
                @click="hideDropdown"
              >
                <span>{{ item }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </vue-custom-scrollbar>
        </div>
        <b-dropdown-item
          separator
        />
        <b-dropdown-item
          v-if="legend.length"
          custom
        >
          <div class="rex-durations__legend">
            <div
              v-for="(item, index) in legend"
              :key="index"
              class="rex-durations__legend-item"
            >
              <div
                class="rex-durations__legend-item-color"
                :style="{
                  'background-color': item.color
                }"
              />
              <p class="rex-durations__legend-item-label">
                {{ item.label }}
              </p>
            </div>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </b-field>
</template>